import { Card } from "./ui/Card";

interface MetricCardProps {
  label: string;
  value: string;
}

export function MetricCard({ label, value }: MetricCardProps) {
  return (
    <Card className="rounded-2xl bg-slate-50 p-5 shadow-sm">
      <div className="text-3xl font-black tracking-tight text-slate-950">{value}</div>
      <div className="mt-1 text-sm text-slate-600">{label}</div>
    </Card>
  );
}
